import { AditionalServiceCostCalculator } from "./aditionalServiceCostCalculator";
import { currencyFormatter } from "./formatting";
import { applySeasonalDiscount } from "./seasonalDiscount";

const  {  ACADEMIC_LEVEL_IDENTIFIERS, DEADLINES, SPACING_OPTIONS, TYPE_OF_PAPERS_MULTIPLIERS, TYPE_OF_ENGLISH_MULTIPLIERS, WRITING_TYPES_MULTIPLIERS, SPACING_MULTIPLIERS } = require("../constants/commonConstants")



export const calculateCost = ({
    academicLevel,
    deadline,
    spacing,
    pages,
    typeOfPaper,
    budgetIncrement=0,
    writingType,
    typeOfEnglish,
    aditionalServices,
    returnDetails = false,
    additionalDiscountPercent = 0,
    additionalDiscountName = "",
    additionalDiscountType = "",
    baseDiscountName
  }) => {
      try{
          
        if(!deadline || !spacing || !pages || !typeOfPaper || !academicLevel || !writingType || !typeOfEnglish){
            return currencyFormatter.format(0);
        }

        deadline = DEADLINES.find(element => element.name === deadline)?.value
        if(!deadline){
            return currencyFormatter.format(0);
        }
        
        let costPerPage; // Base Cost Per Page
    
        //base cost
      if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.COLLEGE ) {
    
        switch(deadline){
            case 21:
                costPerPage = 16.5
                break
            case 14:
                costPerPage = 16.5
                break
            case 10:
                costPerPage = 18.7
                break
            case 6:
                costPerPage = 19.6
                break
            case 4:
                costPerPage = 20.6
                break
            case 2:
                costPerPage = 21.7
                break
            case 1:
                costPerPage = 23
                break
            case 0.5: 
                costPerPage = 24.3
                break
            case 0.25:
                costPerPage = 25.6
                break
            case 0.125:
                costPerPage = 27.1
                break
        }
    
      } else if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.UNIVERSITY) {
    
        switch(deadline){
            case 21:
                costPerPage = 17.6
                break
            case 14:
                costPerPage = 17.6
                break
            case 10:
                costPerPage = 19.8
                break
            case 6:
                costPerPage = 20.8
                break
            case 4:
                costPerPage = 21.8
                break
            case 2:
                costPerPage = 23
                break
            case 1:
                costPerPage = 24.4
                break
            case 0.5: 
                costPerPage = 25.7
                break
            case 0.25:
                costPerPage = 27.1
                break
            case 0.125:
                costPerPage = 28.7
                break
        }
    
      } else if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.MASTERS) {
    
        switch(deadline){
            case 21:
                costPerPage = 20.9
                break
            case 14:
                costPerPage = 20.9
                break
            case 10:
                costPerPage = 23.1
                break
            case 6:
                costPerPage = 24.3
                break
            case 4:
                costPerPage = 25.4
                break
            case 2:
                costPerPage = 26.8
                break
            case 1:
                costPerPage = 28.4
                break
            case 0.5: 
                costPerPage = 30
                break
            case 0.25:
                costPerPage = 31.6
                break
            case 0.125:
                costPerPage = 33.5
                break
        }
    
      } else if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.DOCTORATE) {
    
        switch(deadline){
            case 21:
                costPerPage = 23.1
                break
            case 14:
                costPerPage = 23.1
                break
            case 10:
                costPerPage = 26.4
                break
            case 6:
                costPerPage = 27.7
                break
            case 4:
                costPerPage = 29
                break
            case 2:
                costPerPage = 30.6
                break
            case 1:
                costPerPage = 32.5
                break
            case 0.5: 
                costPerPage = 34.3
                break
            case 0.25:
                costPerPage = 36.2
                break
            case 0.125:
                costPerPage = 38.3
                break
        }
      }
    
        // Adjust cost per page for spacing
        if (spacing) {
           switch (spacing) {
            case SPACING_OPTIONS.DOUBLE_SPACING.label:
                costPerPage *= SPACING_OPTIONS.DOUBLE_SPACING.multiplier;
                break;
            case SPACING_OPTIONS.ONE_POINT_FIVE_SPACING.label:
                costPerPage *= SPACING_OPTIONS.ONE_POINT_FIVE_SPACING.multiplier;
                break;
            case SPACING_OPTIONS.SINGLE_SPACING.label:
                costPerPage *= SPACING_OPTIONS.SINGLE_SPACING.multiplier;
                break;
            default:
                break;
           } 
        }
    
        //extra cost for selected paper types
        const paperTypeMultiplyer = TYPE_OF_PAPERS_MULTIPLIERS.find(paper => paper.name === typeOfPaper)?.paperTypeMultiplier || 0
        const writingTypeMultiplier = WRITING_TYPES_MULTIPLIERS.find(type => type.name === writingType)?.writingTypeMultiplier || 0
        const englishTypeMultiplier = TYPE_OF_ENGLISH_MULTIPLIERS.find(type => type.name === typeOfEnglish)?.englishTypeMultiplier || 0

        let orderCost = Math.round(
            costPerPage * pages * paperTypeMultiplyer * writingTypeMultiplier * englishTypeMultiplier
        )

        //todo: need to calculate the aditional services cost
        let aditionalServicesCost = 0;
        let totalCost = 0;

        const serviceBaseOrderCost = orderCost;

        if(aditionalServices?.length > 0) {
            aditionalServices.forEach(service => {
                aditionalServicesCost += AditionalServiceCostCalculator(
                    service,
                    serviceBaseOrderCost,
                    costPerPage,
                    pages
                ) 
            });
   
        };
    
        // Apply a discount for Powerpoint presentations (70% cheaper)
        if (typeOfPaper === "Powerpoint") {
            orderCost *= 0.7; // Reduce total cost by 30%
        }

        const baseTotalCost = orderCost + aditionalServicesCost;
        const discountDetails = applySeasonalDiscount(baseTotalCost, {
            additionalPercent: additionalDiscountPercent,
            additionalName: additionalDiscountName,
            additionalType: additionalDiscountType,
            baseName: baseDiscountName,
        });
        totalCost = baseTotalCost + budgetIncrement;
        const discountedTotalCost = Number((discountDetails.price + budgetIncrement).toFixed(2));

        if(returnDetails){
            if(isNaN(orderCost) || isNaN(costPerPage) || isNaN(totalCost)){
                return { orderCost: 0, serviceBaseOrderCost: 0, aditionalServicesCost: 0, costPerPage: 0, totalCost: 0, discountedTotalCost: 0, discount: null }
            }
            return {
                orderCost,
                serviceBaseOrderCost,
                aditionalServicesCost,
                costPerPage,
                totalCost,
                discountedTotalCost,
                discount: discountDetails.discount
            }
        }

        if(isNaN(totalCost)){
            return currencyFormatter.format(0);
        }
        return (currencyFormatter.format(discountedTotalCost.toFixed(2))) || "$ 0.00"

    }catch(error){
        console.log(error);
        return currencyFormatter.format(0);
    }
}
